// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__4zBPq","log":"ModalInventoryLogs_log__26uQ_","date":"ModalInventoryLogs_date__Vd-JP","userName":"ModalInventoryLogs_userName__xkIr5"};